import { render, staticRenderFns } from "./CouponDescribe.vue?vue&type=template&id=2cb8dfa9&scoped=true"
import script from "./CouponDescribe.vue?vue&type=script&lang=js"
export * from "./CouponDescribe.vue?vue&type=script&lang=js"
import style0 from "./CouponDescribe.vue?vue&type=style&index=0&id=2cb8dfa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb8dfa9",
  null
  
)

export default component.exports